import { z } from "zod";
import { writeToBookingEntry } from "../_lib/crm-schemas";
import { eventTypeAppCardZod } from "../eventTypeAppCardZod";

export { CrmFieldType, DateFieldType, WhenToWrite } from "../_lib/crm-enums";
export { writeToBookingEntry, writeToRecordEntrySchema } from "../_lib/crm-schemas";

export const appDataSchema = eventTypeAppCardZod.extend({
  ignoreGuests: z.boolean().optional(),
  skipContactCreation: z.boolean().optional(),
  setOrganizerAsOwner: z.boolean().optional(),
  overwriteContactOwner: z.boolean().optional(),
  onBookingWriteToEventObject: z.boolean().optional(),
  onBookingWriteToEventObjectFields: z.record(z.string(), writeToBookingEntry).optional(),
  onBookingWriteMarketingTouchpoint: z.boolean().optional(),
  roundRobinLeadSkip: z.boolean().optional(),
  ifFreeEmailDomainSkipOwnerCheck: z.boolean().optional(),
});

// The client credentials are optional because a service key replaces them, and shouldEnableApp
// validates these keys to decide the app's enabled flag (see seed-app-store): with a service key the
// OAuth fields stay empty and the app still has to come out enabled, otherwise it never shows up.
// The fields accept "", because the admin form posts missing values as empty strings
// (listLocal.handler.ts). In the OAuth mode both halves belong together; seed-app-store and
// `installed` in _metadata enforce that, this schema stays a plain object on purpose: the admin app
// list enumerates its fields with keyof(), which a cross-field rule would take away.
export const appKeysSchema = z.object({
  client_id: z.string().optional(),
  client_secret: z.string().optional(),
  // The Marketing Touchpoints object is a custom object, so its type id (a string like 2-12345678)
  // is assigned per portal. Set it as HUBSPOT_MARKETING_TOUCHPOINT_OBJECT_TYPE_ID in the
  // environment: seed-app-store writes App.keys on every boot, so a value entered in the admin UI is
  // overwritten. Without it the Marketing Touchpoint write stays off.
  marketing_touchpoint_object_type_id: z.string().optional(),
});
